// Notifications controller

"use strict";

import { ApiNotifications } from "@/api/api-group-notifications";
import { Timeouts } from "@/utils/timeout";
import { Request } from "@asanrom/request-browser";
import { AppEvents } from "./app-events";
import { AuthController } from "./auth";

const CHECK_NOTIFICATIONS_REQ_ID = "notifications-check";

/**
 * Notifications controller
 */
export class NotificationsController {
    // Count of unread notifications
    public static UnreadNotificationsCount = 0;

    public static Initialize() {
        AppEvents.AddEventListener("auth-status-changed", NotificationsController.CheckNotifications);
        setInterval(NotificationsController.CheckNotificationsInterval, 5000);

        NotificationsController.CheckNotifications();
    }

    private static CheckingNotifications = false;

    public static CheckNotificationsInterval() {
        if (!NotificationsController.CheckingNotifications) {
            NotificationsController.CheckNotifications();
        }
    }

    public static CheckNotifications() {
        Timeouts.Abort(CHECK_NOTIFICATIONS_REQ_ID);
        Request.Abort(CHECK_NOTIFICATIONS_REQ_ID);

        if (!AuthController.hasPermission("notification.read")) {
            NotificationsController.CheckingNotifications = false;
            NotificationsController.UnreadNotificationsCount = 0;
            AppEvents.Emit("notification-count-update", NotificationsController.UnreadNotificationsCount);
            return;
        }

        NotificationsController.CheckingNotifications = true;

        Request.Pending(CHECK_NOTIFICATIONS_REQ_ID, ApiNotifications.CountUnread())
            .onSuccess((response) => {
                NotificationsController.CheckingNotifications = false;
                NotificationsController.UnreadNotificationsCount = response.count;
                AppEvents.Emit("notification-count-update", NotificationsController.UnreadNotificationsCount);
            })
            .onRequestError((err, handleErr) => {
                handleErr(err, {
                    unauthorized: () => {
                        NotificationsController.CheckingNotifications = false;
                        NotificationsController.UnreadNotificationsCount = 0;
                        AppEvents.Emit("notification-count-update", NotificationsController.UnreadNotificationsCount);
                    },
                    forbidden: () => {
                        NotificationsController.CheckingNotifications = false;
                        NotificationsController.UnreadNotificationsCount = 0;
                        AppEvents.Emit("notification-count-update", NotificationsController.UnreadNotificationsCount);
                    },
                    temporalError: () => {
                        Timeouts.Set(CHECK_NOTIFICATIONS_REQ_ID, 1500, NotificationsController.CheckNotifications);
                    },
                });
            })
            .onUnexpectedError((err) => {
                console.error(err);
                Timeouts.Set(CHECK_NOTIFICATIONS_REQ_ID, 1500, NotificationsController.CheckNotifications);
            });
    }
}

NotificationsController.Initialize();
